import { render, staticRenderFns } from "./healthdata.vue?vue&type=template&id=9d8dbf94&"
import script from "./healthdata.vue?vue&type=script&lang=js&"
export * from "./healthdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports